import bannerBg from '../assets/img/page-banner.jpg';
import PageBanner from '../components/PageBanner';
import Header3 from '../components/Header3';
import Footer3 from '../components/Footer3';
import { Helmet } from 'react-helmet';
import ShoppingCart from '../components/Cart/ShoppingCart';

function Cart() {
    return (
        <>
            <Helmet>
            <title>{`Testfabrics.com: ${("Shopping Cart").slice(0,60).toUpperCase()}`}</title>

            </Helmet>
            <Header3 />
            <PageBanner bannerBg={bannerBg} heading={"Shopping Cart"} currentPage={"Cart"} />
            <ShoppingCart/>
            <br/>
            <Footer3 />
        </>
    );
}

export default Cart;
